// FontAwesome Brands setup using the installed packages
import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// Import specific brand icons
import {
	faShopify
} from '@fortawesome/free-brands-svg-icons'

// Add icons to the library
library.add(
	faShopify
)

// Register the FontAwesome component globally
Vue.component('font-awesome-icon', FontAwesomeIcon)

// Add CSS for FontAwesome to work with v-icon
const style = document.createElement('style')
style.textContent = `
.v-icon.fab {
  font-family: inherit !important;
}

.v-icon .svg-inline--fa {
  vertical-align: baseline !important;
}
`
document.head.appendChild(style)
